import { ActionTypes } from "../../../constants/ActionConstants";

export const planCampaign = (campaignId, isAddCity, history, isPureDooh) => ({
  type: ActionTypes.CampaignPlanner.PLAN_CAMPAIGN,
  payload: { campaignId, isAddCity, history, isPureDooh },
});

export const setTitle = (titleStr) => ({
  type: ActionTypes.CampaignPlanner.SET_CAMPAIGN_TITLE,
  payload: { titleStr },
});

export const setTgCpm = (tgCpmStr) => ({
  type: ActionTypes.CampaignPlanner.SET_TG_CPM,
  payload: { tgCpmStr },
});

export const setGenCpm = (genCpmStr) => ({
  type: ActionTypes.CampaignPlanner.SET_GEN_CPM,
  payload: { genCpmStr },
});

export const restoreCampaignPlan = (campaignId, cityId) => ({
  type: ActionTypes.CampaignPlanner.RESTORE_CAMPAIGN_PLAN,
  payload: { campaignId, cityId },
});

export const updateCampaignDates = (dateObj, dayCount) => ({
  type: ActionTypes.CampaignPlanner.CHANGE_DURATION,
  payload: { dateObj, dayCount },
});

export const getTgSpecificOts = (
  tgId,
  stretchIds = [],
  segmentIds = [],
  mediaIds = []
) => ({
  type: ActionTypes.CampaignPlanner.GET_TG_SPECIFIC_OTS,
  payload: { tgId, stretchIds, segmentIds, mediaIds },
});

// Dispatch function for TgSpecificOts for all "ROAD-STRETCHES" in "CITY"
export const getTgSpecificOtsForCity = (
  tgId,
  cityId,
  roadStretchesDataMap
) => ({
  type: ActionTypes.CampaignPlanner.GET_TG_SPECIFIC_OTS_FOR_CITY,
  payload: { tgId, cityId, roadStretchesDataMap },
});

// Dispatch function for TgSpecificOts for "ROAD-SEGMENTS"
export const getTgSpecificOtsForSegments = (tgId, segmentIds) => ({
  type: ActionTypes.CampaignPlanner.GET_TG_SPECIFIC_OTS_FOR_SEGMENTS,
  payload: { tgId, segmentIds },
});

// clear TgSpecificOts for "ROAD-SEGMENTS"
export const clearTgSpecificOtsForSegments = () => ({
  type: ActionTypes.CampaignPlanner.CLEAR_TG_SPECIFIC_OTS_FOR_SEGMENTS,
});

export const removeSelectedTg = () => ({
  type: ActionTypes.CampaignPlanner.RESET_TG_SPECIFIC_OTS,
});

export const getRegionsData = (cityId, isPureDooh) => ({
  type: ActionTypes.CampaignPlanner.GET_REGIONS,
  payload: { cityId, isPureDooh },
});

export const resetCampaignPlanning = () => ({
  type: ActionTypes.CampaignPlanner.RESET_PLAN_CAMPAIGN,
});

export const selectTgAttribute = (tgAttribute) => ({
  type: ActionTypes.CampaignPlanner.SELECT_TG_ATTRIBUTE,
  payload: { tgAttribute },
});

export const unSelectTgAttribute = (tgAttribute) => ({
  type: ActionTypes.CampaignPlanner.UN_SELECT_TG_ATTRIBUTE,
  payload: { tgAttribute },
});

export const clearSelectedTgAttributes = () => ({
  type: ActionTypes.CampaignPlanner.CLEAR_TG_ATTRIBUTES,
});

export const restoreTgAttributeMap = (tgAttrMap) => ({
  type: ActionTypes.CampaignPlanner.RESTORE_TG_ATTRIBUTES,
  payload: { tgAttrMap },
});

export const toggleMediaType = (mediaTypes) => ({
  type: ActionTypes.CampaignPlanner.TOGGLE_MEDIA_TYPE,
  payload: { mediaTypes },
});

// Manage Tg(create & update) & generate Heatmap and get tgOts for city stretches
export const manageTgAndGetTgOtsForCityStretches = (
  tgBean,
  resPoiLayers,
  cityId,
  cityBBox,
  setSelectedTab
) => ({
  type: ActionTypes.CampaignPlanner.MANAGE_TG_AND_GET_TG_OTS_FOR_CITY_STRETCHES,
  payload: { tgBean, resPoiLayers, cityId, cityBBox, setSelectedTab },
});

// hovered stretch
export const setHoveredStretchId = (stretchId) => ({
  type: ActionTypes.CampaignPlanner.SET_HOVERED_STRETCH_ID,
  payload: { stretchId },
});

export const selectTouchPoint = (touchPoint) => ({
  type: ActionTypes.CampaignPlanner.SELECT_TOUCH_POINT,
  payload: { touchPoint },
});

export const unSelectTouchPoint = (touchPoint) => ({
  type: ActionTypes.CampaignPlanner.UN_SELECT_TOUCH_POINT,
  payload: { touchPoint },
});
